import ReviewTiles from 'components/ReviewTileDashboard';
import useDashboard from 'hooks/API/GET/useDashboard';

function SeDashboard({ reviewData = [] }) {
  const {
    notes = [],
    videos = [],
    stories = [],
    geeks = [],
    quizzes = [],
    mindMaps = [],
  } = reviewData;
  return (
    <>
      <ReviewTiles
        notes={notes}
        videos={videos}
        stories={stories}
        geeks={geeks}
        quizzes={quizzes}
        mindMaps={mindMaps}
        title={"Action required! Review request from QC's/Teacher's"}
      />
    </>
  );
}

export default SeDashboard;
